module.exports = __webpack_public_path__ + "img/bind-jd-1.175964bd.png";